import type {
  NecrologiSearchQuery,
  NecrologiSearchResponse,
  NecrologiStats,
  NecrologioDTO,
} from "../../api/contract";
import { apiGet, apiPost, buildQuery } from "./http";
import type { Omonimo } from "./sister-browser";

export function listNecrologi(q: NecrologiSearchQuery = {}, signal?: AbortSignal): Promise<NecrologiSearchResponse> {
  return apiGet<NecrologiSearchResponse>(`/api/necrologi${buildQuery(q as Record<string, unknown>)}`, signal);
}

export function getNecrologiStats(): Promise<NecrologiStats> {
  return apiGet<NecrologiStats>("/api/necrologi/stats");
}

export function discardNecrologio(id: number | string): Promise<NecrologioDTO> {
  return apiPost<NecrologioDTO>(`/api/necrologi/${id}/discard`);
}

export function restoreNecrologio(id: number | string): Promise<NecrologioDTO> {
  return apiPost<NecrologioDTO>(`/api/necrologi/${id}/restore`);
}

export interface NecrologioMatchHistoryItem {
  id: number;
  searchedAt: number;
  status: string;
  cognomeUsed: string | null;
  nomeUsed: string | null;
  annoUsed: number | null;
  omonimi: Omonimo[] | null;
  matchedCf: string | null;
  numImmobili: number | null;
  pdfPath: string | null;
  error: string | null;
}

export function getNecrologioMatchHistory(id: number | string): Promise<{ items: NecrologioMatchHistoryItem[] }> {
  return apiGet<{ items: NecrologioMatchHistoryItem[] }>(`/api/necrologi/${id}/match-immobili/history`);
}
